import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { usePosition, useShow } from "@website/ui/mini-popover/hooks";
import styles from "@website/ui/mini-popover/mini-popover.module.scss";
import { MiniPopoverPropertiesType } from "@website/ui/mini-popover/mini-popover.types";
import { TransitionV2 } from "@website/ui/transition";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { FC, useRef } from "react";
import { createPortal } from "react-dom";
export const MiniPopover: FC<MiniPopoverPropertiesType> = properties => {
  const {
    animate,
    children,
    title,
    fullWidth,
    gap,
    className,
    usePortal = false,
    popoverClassName,
    mainClassName,
    skipClientLoadedCheck = false
  } = properties;
  const popoverReference = useRef<HTMLDivElement>(null);
  const body = useRef<HTMLElement | null>(typeof document === "undefined" ? null : document.body);
  const {
    popoverProperties,
    transitionProps,
    closeButtonProps,
    popoverOpen,
    animateOpen
  } = useShow(properties, popoverReference);
  const {
    horizontalPosition
  } = usePosition(properties, popoverReference);
  const {
    isMobile
  } = useViewPort();
  const content = <TransitionV2 {...transitionProps} in={animateOpen}>
      {state => <div className={`${className} ${styles["container"]} ${animate === "normal" ? "" : `${styles["animate-bottom"]} ${styles[state]}`} ${fullWidth ? styles["full"] : ""} ${styles[horizontalPosition]} `} style={{
      marginTop: isMobile ? "0px" : gap || "0px"
    }}
    // ref={sheetReference}
    // style={isMobile ? { bottom: `${sheetBottom}px` } : {}}
    // style={{ height: isMobile ? `${containerHeight}px` : "auto" }}
    >
          <div ref={popoverReference} {...popoverProperties} className={`${styles["mini-popover"]} ${popoverClassName || ""}`}>
            {title ? <div className={styles["header"]}>
                <div className={styles["title"]}>{title}</div>
                <div className={styles["close-button"]}>
                  <MaterialIcon className={styles["close-button-icon"]} name="close" {...closeButtonProps} />
                </div>
              </div> : null}
            <div className={`${styles["main"]} ${mainClassName || ""}`}>
              {children}
            </div>
          </div>
        </div>}
    </TransitionV2>;
  const {
    clientLoaded
  } = useClientLoaded();
  if (!popoverOpen || !skipClientLoadedCheck && !clientLoaded) return null;
  return usePortal && body.current ? createPortal(content, body.current) : content;
};